export const switchButtonStyle = (isActive, disabled) => ({
    backgroundColor: isActive ? '#0b5e3b' : '#f8fafc',
    color: isActive ? '#fff' : '#475569',
    padding: '8px 18px',
    borderRadius: '999px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: '600',
    fontSize: '0.78rem',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    minWidth: '132px',
    textAlign: 'center',
    opacity: disabled ? 0.6 : 1,
    transition: 'background-color 0.18s ease, color 0.18s ease, border-color 0.18s ease',
    border: isActive ? '1px solid #0b5e3b' : '1px solid rgba(15, 23, 42, 0.12)',
    letterSpacing: '0.04em'
});